import api from './api';

const ADMIN_URL = '/form-config';

export const FormConfigService = {
  // ── Admin endpoints ────────────────────────────────────────────────────
  async getDefault() {
    return (await api.get(`${ADMIN_URL}/default`)).data;
  },

  async seedDefault() {
    return (await api.post(`${ADMIN_URL}/seed`)).data;
  },

  async getByBookingId(bookingId) {
    return (await api.get(`${ADMIN_URL}/booking/${bookingId}`)).data;
  },

  async cloneForBooking(bookingId) {
    return (await api.post(`${ADMIN_URL}/booking/${bookingId}/clone`)).data;
  },

  async saveForBooking(bookingId, data) {
    return (await api.put(`${ADMIN_URL}/booking/${bookingId}`, data)).data;
  },

  async updateById(id, data) {
    return (await api.put(`${ADMIN_URL}/${id}`, data)).data;
  },

  // ── Public endpoint (no auth, used by bus form) ────────────────────────
  async getPublicConfig(bookingId) {
    return (await api.get(`${ADMIN_URL}/public/${bookingId}`)).data;
  },
};

export default FormConfigService;
